import { Routes } from '@angular/router';

import { LoginComponent } from './login.component';
import { ForgotComponent } from './forgot.component';
import { SetupPasswordComponent } from './setup-password/setup-password.component';

export const LOGIN_ROUTES: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotComponent },
    { path: 'setup-password', component: SetupPasswordComponent }
];
